import { useEffect, useRef } from 'react';
import { useGetTrackFileById } from 'services/tracks/file';

interface AudioPlayerProps {
  trackId: string;
  url: string;
}

const AudioPlayer = ({ trackId, url }: AudioPlayerProps) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  const { data: audioUrl } = useGetTrackFileById('');

  useEffect(() => {
    audioRef.current?.load();
  }, [trackId, url]);

  return (
    <audio ref={audioRef} controls controlsList='noplaybackrate nodownload'>
      {url && <source src={url} type='audio/mpeg' />}
    </audio>
  );
};

export default AudioPlayer;
